export default "__VITE_ASSET__qqXM6t2T__"